import { ProductLink, ProductLinkProps } from '@portals/core/src/components/ProductLink/ProductLink';
import React, { useCallback } from 'react';

import { useSPKCookie } from '../../../hooks/useSPKCookie/useSPKCookie';

export type OnSelectBankFn = ({ bankCode, bankName }: { bankCode: string; bankName: string }) => void;

interface Props extends Omit<ProductLinkProps, 'children'> {
  bankCode: string;
  name: string;
  onSelectBank?: OnSelectBankFn;
}

export const SparkasseAssignBankButton: React.FunctionComponent<Props> = ({
  bankCode,
  name,
  onSelectBank,
  ...props
}: Props) => {
  const { setCookie } = useSPKCookie();

  const onClick = useCallback(() => {
    setCookie(bankCode, name, 'SparkasseAssignment');
    if (onSelectBank) {
      onSelectBank({ bankCode, bankName: name });
    }
  }, [bankCode, name, setCookie, onSelectBank]);

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLLIElement>) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick]
  );

  return (
    <ProductLink component="li" onClick={onClick} onKeyDown={onKeyDown} {...props}>
      {name}
    </ProductLink>
  );
};
